
enum RoleEnum {
    Admin = "admin",
    TenantAdmin = "tenantadmin",
    TenantSupervisor = "tenantsupervisor",
    TenantUser = "user"
}

export default RoleEnum
